import React, { createContext, useContext, useMemo } from "react";
import { useStrapiConfig } from "hooks/useStrapiConfig";
import { deepMergeConfig } from "services/strapi.service";
import defaultText from "config/text.json";
import { TextContent } from "types";

const FALLBACK_TEXT = defaultText as unknown as TextContent;

const TextContext = createContext<TextContent>(FALLBACK_TEXT);

// Strapi's `labels` field is deep-merged over the local text.json fallback,
// field by field, the same way `login_page_style` merges over
// fallbackLoginPageStyle.json — a missing/partial `labels` response still
// resolves to fully-populated copy.
const TextProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const { data: loginPageConfig } = useStrapiConfig();
  const text = useMemo(() => deepMergeConfig(loginPageConfig?.labels, FALLBACK_TEXT), [loginPageConfig]);

  return <TextContext.Provider value={text}>{children}</TextContext.Provider>;
};

export function useText(): TextContent {
  return useContext(TextContext);
}

export default TextProvider;
